module.exports = __webpack_public_path__ + "img/slide-11.dfde1f4e.jpg";